import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'
import { PickingStatus, RefundStatus } from 'types/model/product'

export const pickingStatusInfo = (pickingStatus: PickingStatus) => {
  const { t } = useTranslation()
  let fill
  let status
  switch (pickingStatus.toLowerCase()) {
    case PickingStatus.PICKED:
      fill = theme.palette.success.main
      status = t('orderProduct.picked')
      break
    case PickingStatus.SUBSTITUTED:
      fill = theme.palette.warning.main
      status = t('orderProduct.substituted')
      break
    case PickingStatus.NOT_AVAILABLE:
      fill = theme.palette.error.main
      status = t('orderProduct.notAvailable')
      break
    case PickingStatus.OPEN:
      fill = theme.palette.text.secondary
      status = t('orderProduct.open')
      break
    case PickingStatus.QUANTITY_CHANGED:
      fill = theme.palette.success.main
      status = t('orderProduct.picked')
      break
    default:
      fill = ''
      status = ''
  }

  return { fill, status }
}
export const useRefundInfo = () => {
  const { t } = useTranslation()
  return (status: string) => {
    if (status === RefundStatus.COMPLETED) {
      return {
        backgroundColor: theme.palette.success.main,
        tooltip: t('orderProduct.successful'),
      }
    }
    if (status === RefundStatus.FAILED) {
      return {
        backgroundColor: theme.palette.error.main,
        tooltip: t('orderProduct.failed'),
      }
    }
    if (status === RefundStatus.PENDING) {
      return {
        backgroundColor: theme.palette.text.secondary,
        tooltip: t('orderProduct.pending'),
      }
    }
    return { backgroundColor: 'transparent', tooltip: '' }
  }
}
